import React from 'react'
import { arrayOf, bool, func, number, string } from 'prop-types'
import { Trans } from '@lingui/macro'

import ButtonGhost from 'views/components/molecules/ButtonGhost'
import Form from 'views/components/atoms/Form'
import Button from 'views/components/atoms/Button'
import SearchBoxListItem from 'views/components/organisms/SearchBox/SearchBoxListItem'

import Experiment from 'views/components/utils/optimizely/Experiment'
import Variant from 'views/components/utils/optimizely/Variant'
import { AFTER_QUERY_SUGGEST_LAYER } from 'shared/experiments/consts'
import AfterQuerySuggestLayer from 'shared/experiments/components/AfterQuerySuggestLayer'

import './SearchBoxList.scss'

const SearchBoxList = ({
  mobile,
  displayResults,
  products,
  query,
  handleItemClick,
  handleShowAll,
  highlightedIndex,
  formAction,
  hideResults,
  handleValueChange
}) => {
  const queryStr = query ? query.toLowerCase() : null
  const ButtonComponent = mobile ? Button : ButtonGhost

  const handleClick = event => {
    if (handleShowAll) {
      handleShowAll(event)
    }
  }

  const aqslProps = {
    query: queryStr,
    products,
    mobile,
    handleItemClick,
    handleClick,
    formAction,
    hideResults,
    handleValueChange,
    displayResults
  }

  return (
    <Experiment name={AFTER_QUERY_SUGGEST_LAYER} preventActivation>
      <Variant name="default">
        {() =>
          displayResults ? (
            <div className="o-SearchBox__results u-padding">
              <ul className="a-list-reset o-SearchBox__list u-margin--bottom">
                {products.map((product, index) => (
                  <SearchBoxListItem
                    mobile={mobile}
                    queryStr={queryStr}
                    key={product.id}
                    handleItemClick={handleItemClick}
                    item={product}
                    highlighted={highlightedIndex === index}
                    last={index + 1 === products.length}
                  />
                ))}
              </ul>
              <div className="o-SearchBox__controls u-text-align--center">
                <Form name="search-results" method="get" action={formAction}>
                  <ButtonComponent
                    name="show-all-results-button"
                    onClick={handleClick}
                  >
                    <Trans id="general.label.showAllResults" />
                  </ButtonComponent>
                </Form>
              </div>
            </div>
          ) : null
        }
      </Variant>

      <Variant name="variation_1">
        {() => (
          <div className="o-SearchBox__results">
            <AfterQuerySuggestLayer {...aqslProps} />
          </div>
        )}
      </Variant>

      <Variant name="variation_2">
        {() => (
          <div className="o-SearchBox__results">
            <AfterQuerySuggestLayer {...aqslProps} twoColumns />
          </div>
        )}
      </Variant>
    </Experiment>
  )
}

SearchBoxList.propTypes = {
  formAction: string.isRequired,
  mobile: bool,
  query: string,
  displayResults: bool,
  products: arrayOf(SearchBoxListItem.propTypes.item),
  handleShowAll: func,
  handleItemClick: func,
  highlightedIndex: number,
  hideResults: func,
  handleValueChange: func
}

SearchBoxList.defaultProps = {
  mobile: false,
  query: '',
  displayResults: false,
  products: [],
  handleShowAll: null,
  handleItemClick: null,
  highlightedIndex: -1,
  hideResults: null,
  handleValueChange: null
}

export default SearchBoxList
